// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"5dc23189","213":"a246806d","309":"6b5a62ff","323":"b3458aaa","343":"d76e1b1b","383":"7890f142","465":"19101109","490":"fc05b116","521":"72c88272","524":"9fe70dc3","682":"901048d9"}[chunkId] + ".chunk.js";
};